import { pct1 } from '../dashboard/capacity-format';

/** Threshold text color for a utilization %: <70 healthy · 70–85 warn · ≥85 crit. */
function usageTextColor(pct: number): string {
  if (pct >= 85) return 'var(--vn-danger-text)';
  if (pct >= 70) return 'var(--vn-warning-text)';
  return 'var(--vn-success-text)';
}

/**
 * Utilization as right-aligned, threshold-colored percentage text — matching the
 * legacy cloud host/datastore tables and the app's plain-text table cells (no
 * in-cell progress bars, which no other table here uses).
 */
export function UsagePctText({ value }: { value: number | null | undefined }) {
  const v = pct1(value);
  return (
    <span style={{ display: 'block', textAlign: 'right', color: usageTextColor(v), fontWeight: 'var(--vn-font-weight-medium)' }}>
      {v}%
    </span>
  );
}

/** Right-aligned plain value cell, for numeric columns (cores, GB, counts). */
export function NumCell({ children }: { children: React.ReactNode }) {
  return <span style={{ display: 'block', textAlign: 'right' }}>{children}</span>;
}

/** Right-aligned header label to sit above numeric / percentage columns. */
export function numHeader(label: string) {
  return () => <span style={{ display: 'block', textAlign: 'right' }}>{label}</span>;
}
